import { Box, CircularProgress, List, Stack, Typography } from '@mui/material';

import RoleListItemCell from './RoleListItemCell';

import type { AccessCentreRole } from 'domains/accessCentre/types';

export type RolePopoverListSectionProps = {
    isRolesLoading: boolean;
    roles: AccessCentreRole[];
    currentRoleId: number;
    listboxId: string;
    selectDisabled: boolean;
    onSelectRole: (role: AccessCentreRole) => void;
};

const RolePopoverListSection = ({
    isRolesLoading,
    roles,
    currentRoleId,
    listboxId,
    selectDisabled,
    onSelectRole,
}: RolePopoverListSectionProps) => (
    <Box sx={{ flex: 1, minHeight: 0, overflow: 'auto', px: 0.5, pb: 1 }}>
        {isRolesLoading ? (
            <Stack alignItems="center" py={3} role="status" aria-label="Loading roles">
                <CircularProgress size={28} />
            </Stack>
        ) : roles.length === 0 ? (
            <Typography color="text.secondary" sx={{ px: 1.5, py: 2 }}>
                No roles found
            </Typography>
        ) : (
            <List
                id={listboxId}
                disablePadding
                role="listbox"
                aria-label="Roles"
                data-testid="access-center-user-role-list"
            >
                {roles.map((role) => (
                    <RoleListItemCell
                        key={role.id}
                        role={role}
                        isSelected={role.id === currentRoleId}
                        selectDisabled={selectDisabled}
                        onSelect={onSelectRole}
                    />
                ))}
            </List>
        )}
    </Box>
);

export default RolePopoverListSection;
